//src/components/Navbar.jsx

import { Navbar, Container, Nav, NavDropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getUser, logout } from "./AuthService";
import logo from "../assets/logo-mark.png";

function AppNavbar({ onMenuClick, menuExpanded = true, isDesktop = true }) {
  const user = getUser();

  const isAdmin = user?.role === "admin";
  const isAdminIT = user?.role === "admin-IT";
  const isManager = user?.role === "manager";

  const toggleLabel = isDesktop
    ? menuExpanded
      ? "Hide menu"
      : "Show menu"
    : menuExpanded
      ? "Close menu"
      : "Open menu";

  return (
    <Navbar expand="lg" bg="white" className="app-navbar sticky-top">
      <Container fluid className="px-2 px-sm-3">
        <div className="d-flex align-items-center gap-2 min-w-0">
          <Button
            variant="link"
            className="sidebar-toggle p-1"
            onClick={onMenuClick}
            aria-label={toggleLabel}
            aria-expanded={menuExpanded}
            title={toggleLabel}
          >
            <i
              className={`bi ${
                menuExpanded ? "bi-layout-sidebar-inset" : "bi-list"
              } fs-4`}
              aria-hidden="true"
            />
          </Button>

          <Link
            to="/dashboard"
            className="app-navbar-logo-wrap"
            aria-label="WEBDOC Dashboard"
          >
            <img src={logo} alt="WEBDOC" className="app-navbar-logo" />
          </Link>
        </div>

        <Navbar.Toggle aria-controls="top-navbar-nav" />
        <Navbar.Collapse id="top-navbar-nav" className="justify-content-end">
          <Nav className="align-items-lg-center">
            {(isAdmin || isAdminIT) && (
              <Nav.Link as={Link} to="/account/users">
                Users
              </Nav.Link>
            )}

            {isManager && (
              <Nav.Link as={Link} to="/account/reports">
                Reports
              </Nav.Link>
            )}

            <NavDropdown
              title={user?.name || "User"}
              id="user-dropdown"
              align="end"
            >
              <NavDropdown.Item as={Link} to="/account/profile">
                Profile
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={logout} className="text-danger">
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppNavbar;
